export enum Environment {
  PROD = 'production',
  DEV = 'development',
}
